import { useEffect } from "react";

// Buttons/actions that are READS or navigation stay enabled in view-only mode.
const SAFE = /(refresh|search|filter|export|download|prev|next|page|pagination|back|close|cancel|logout|sign-out|view|detail|manage|open|expand|collapse|copy|tab|dismiss-toast|clear-filter|reset-filter)/i;
const SAFE_TEXT = /^(refresh|search|filter|export|export csv|download|previous|prev|next|back|close|cancel|view|view details|details|manage|open|copy|clear|clear filters|sign out|log ?out)$/i;

function shouldLock(btn) {
  if (btn.closest('[data-testid="admin-tabs"]')) return false; // navigation tabs
  if (btn.closest('[data-testid="view-only-banner"]')) return false;
  if (btn.hasAttribute("data-ro-safe")) return false;
  const tid = (btn.getAttribute("data-testid") || "").toLowerCase();
  if (tid && SAFE.test(tid)) return false;
  const txt = (btn.textContent || "").trim();
  if (txt && SAFE_TEXT.test(txt)) return false;
  return true;
}

function scopeRoots() {
  const roots = [];
  const tabs = document.querySelector('[data-testid="admin-tabs"]');
  if (tabs && tabs.parentElement) roots.push(tabs.parentElement);
  // Radix dialogs render in a portal outside the page container.
  document.querySelectorAll('[role="dialog"]').forEach((d) => roots.push(d));
  return roots;
}

function apply() {
  scopeRoots().forEach((root) => {
    root.querySelectorAll("button, input[type=submit]").forEach((btn) => {
      if (btn.hasAttribute("data-ro-disabled")) return;
      if (!shouldLock(btn)) return;
      btn.setAttribute("data-ro-disabled", "1");
      btn.setAttribute("data-ro-was-disabled", btn.disabled ? "1" : "0");
      btn.disabled = true;
      btn.classList.add("opacity-50", "cursor-not-allowed");
      btn.setAttribute("title", "View-only access — changes are disabled");
    });
  });
}

function restore() {
  document.querySelectorAll("[data-ro-disabled]").forEach((btn) => {
    if (btn.getAttribute("data-ro-was-disabled") !== "1") btn.disabled = false;
    btn.classList.remove("opacity-50", "cursor-not-allowed");
    btn.removeAttribute("data-ro-disabled");
    btn.removeAttribute("data-ro-was-disabled");
    if (btn.getAttribute("title") === "View-only access — changes are disabled") btn.removeAttribute("title");
  });
}

// Disables write-action buttons in the current admin section when it's view-only.
export default function ReadOnlyLock() {
  useEffect(() => {
    apply();
    let scheduled = false;
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; apply(); });
    };
    const obs = new MutationObserver(schedule);
    obs.observe(document.body, { childList: true, subtree: true });
    return () => { obs.disconnect(); restore(); };
  }, []);
  return null;
}
